export default require("scss/global/" +
  process.env.REACT_APP_TARGET_STYLE.toLocaleLowerCase() +
  ".scss");
